// extracted by mini-css-extract-plugin
module.exports = {"games":"OverflowSlider__games--3DE","game":"OverflowSlider__game--35R"};